import React from 'react';

export default ({ color = '#ED483D', size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill={color}/>
    <path d="M8 4L4 8" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 8L4 4" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
